import { init, send } from "@emailjs/browser";

init(process.env.USER_ID);

const templateParams = {
  to_name: "",
  from_name: "",
  message: "",
};

export const sendEmail = async (data) => {
  const { name, email, contact, work } = data;
  templateParams.from_name = name;
  templateParams.to_name = "Shivam Gavandi";
  templateParams.message = `
    Email: ${email}.
    Mobile no: ${contact}.  
    Work: ${work}
    `;

  const res = await send(
    "service_x54h5se",
    "template_3rhisiy",
    templateParams,
    "HMevCBDA-78DWixkt"
  );

  console.log(res);
  if(res.status === 200 && res.text == 'OK'){
      return true;
  }
  return false;
  
};
